import React, { useState } from 'react';
import { IBusinessLocation } from 'models';
import BusinessLocationCard from 'parent-portal/BusinessLocation/BusinessLocationCard';
import AddBusinessLocationForm from 'parent-portal/BusinessLocation/AddBusinessLocationForm';
import { PrimaryButton, SizeableRoundedDialog } from 'library';
import { Grid, useMediaQuery } from '@mui/material';
import theme from 'theme';
import { IBusinessFaqQuestions } from 'parent-portal/home/Models/DashboardData';
import { useUserContext } from 'UserContext';

export default function CenterLocations({
    businessLocations,
    refreshBusinessLocations,
    faqQuestions,
}: {
    businessLocations: IBusinessLocation[];
    refreshBusinessLocations: () => void;
    faqQuestions: IBusinessFaqQuestions[];
}) {
    const small = useMediaQuery(theme.breakpoints.down('md'));
    const { user } = useUserContext();

    const [addBusinessLocation, setAddBusinessLocation] = useState(false);
    return (
        <>
            <Grid item container style={{ padding: '0px 20px 20px 20px' }} alignContent="center">
                {businessLocations.map((location: IBusinessLocation) => (
                    <BusinessLocationCard key={location.id} businessLocation={location} faqQuestions={faqQuestions} />
                ))}
                {user?.role === 'BUSINESS' && (
                    <Grid item container style={{ justifyContent: 'right' }}>
                        <PrimaryButton onClick={() => setAddBusinessLocation(true)} buttonStyle={{ maxWidth: 200 }}>
                            Add Location
                        </PrimaryButton>
                    </Grid>
                )}
            </Grid>
            <SizeableRoundedDialog
                open={addBusinessLocation}
                onClose={() => setAddBusinessLocation(false)}
                closeButton
                style={{ maxWidth: small ? '100%' : 300 }}
            >
                <AddBusinessLocationForm
                    cancel={() => setAddBusinessLocation(false)}
                    complete={() => {
                        refreshBusinessLocations();
                        setAddBusinessLocation(false);
                    }}
                    optionalContact
                />
            </SizeableRoundedDialog>
        </>
    );
}
